<div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
    <div class="d-flex gap-2 align-items-center flex-wrap">
        <h4 class="m-0">{{ title() }}</h4>
        <ng-content select="[entitiesHeaderExtra]"></ng-content>
    </div>
    <div class="d-flex gap-2 align-items-center">
        @if (!hideEntities() && !appSettings.isMobile()) {
        <div class="input-group input-group-sm" style="width: 200px;">
            <span class="input-group-text bg-light border-end-0">
                <i class="fas fa-search text-muted"></i>
            </span>
            <input type="text" class="form-control border-start-0 ps-0" placeholder="Buscar entidad..."
                [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)">
        </div>
        }
        @if (canManage() && !hideEntities()) {
        <button class="btn btn-primary btn-sm" (click)="addEntity()">
            <i class="fas fa-plus"></i> Añadir
        </button>
        }
    </div>
</div>

@if (!hideEntities() && appSettings.isMobile()) {
<div class="mb-2">
    <input type="text" class="form-control py-2 border-0 shadow-sm" placeholder="Buscar entidad..."
        [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)">
</div>
<div class="nested-cards-list">
    @for (entity of filteredEntities(); track entity.id ?? entity.code) {
        <app-list-card>
            <div cardTitle class="fw-bold text-dark text-truncate">{{ entity.name }}</div>
            <div cardBadge>
                <span class="badge text-bg-secondary">{{ entity.code }}</span>
            </div>
            @if (canManage()) {
            <div cardActionsRow>
                <button type="button" class="btn btn-sm btn-outline-danger w-100"
                    (click)="removeEntity(entity.code)"
                    [disabled]="!canRemoveEntity(entity.code)">
                    <i class="fas fa-trash me-1"></i> Quitar
                </button>
            </div>
            }
        </app-list-card>
    } @empty {
        <div class="card border-0 shadow-sm p-4 text-center my-2">
            <i class="fas fa-info-circle fa-2x text-muted opacity-50 mb-2"></i>
            <h6 class="text-muted mb-1">
                {{ searchTerm() ? 'No hay resultados para la búsqueda.' : emptyMessage() }}
            </h6>
        </div>
    }
</div>
} @else if (!hideEntities()) {
<div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
    <table class="table table-hover">
        <thead class="sticky-top shadow-sm">
            <tr>
                <th style="width: 100px;">Código</th>
                <th>Entidad</th>
                @if (canManage()) {
                <th class="text-center" style="width: 80px;">Acción</th>
                }
            </tr>
        </thead>
        <tbody>
            @for (entity of filteredEntities(); track entity.id ?? entity.code) {
            <tr>
                <td>{{ entity.code }}</td>
                <td>{{ entity.name }}</td>
                @if (canManage()) {
                <td class="text-center">
                    <button class="btn btn-outline-danger btn-xs" (click)="removeEntity(entity.code)"
                        [disabled]="!canRemoveEntity(entity.code)"
                        [title]="canRemoveEntity(entity.code) ? 'Eliminar entidad' : 'No tienes permisos para eliminar esta entidad'">
                        <i class="fas fa-trash"></i>
                    </button>
                </td>
                }
            </tr>
            } @empty {
            <tr>
                <td [attr.colspan]="canManage() ? 3 : 2" class="text-center text-muted p-4">
                    <i class="fas fa-info-circle fa-2x mb-2 d-block opacity-50"></i>
                    {{ searchTerm() ? 'No hay resultados para la búsqueda.' : emptyMessage() }}
                </td>
            </tr>
            }
        </tbody>
    </table>
</div>
}
